import EditBenefitGroup from './EditBenefitGroup'

export default EditBenefitGroup
